// extracted by mini-css-extract-plugin
export default {"body":"body--aT9sv","divider":"divider--yHC1F","text":"text--c2u9J"};